<div id=rulesPage>
	<h1>Kräfte</h1>

	<h2>{domain.name} ({domain.ID})</h2>

	<p>{domain.descript}</p>

	<div class="cardsBox">
		{#each powers as power}
			<ActionCard action={power} />
		{/each}
	</div>
</div>


<script>
	import { user, game, view } from "../client.svelte.js"
	import {protoActions, protoDomains, calc_activityColor} from "../core.js"
	import Select from "../elements/Select.svelte";
	import ActionCard from "../elements/ActionCard.svelte";

	let { domainID } = $props()
  let domain = $derived(protoDomains[domainID] ?? {name: "", descript: ""})
	let powers = $derived(
		Object.values(protoActions)
			.filter(pow => pow.domain === domainID)
			.sort((a,b) => a.exertion - b.exertion)
	)

	$inspect(`DOMAINS - show domain ${domainID}`, domain)
</script>


<style lang="sass">
	#rulesPage
		height: 100vh
		overflow: auto

	.cardsBox
		display: flex
		flex-wrap: wrap

	.powerBox
		display: grid
		grid-template-columns: 10ch 1fr 2fr
		margin: 0 2ch
		padding: 6px
		grid-gap: 4px

	.powerDescript
		grid-row: span 3
		background: #666666
</style>